import './index.scss'

$(document).ready(function() {
    if ($(this).scrollTop() > 100) { // 当页面滚动超过100px时显示按钮
        $('#backToTop').fadeIn();
    } else {
        $('#backToTop').fadeOut();
    }
    // 当页面滚动时显示或隐藏返回顶部按钮
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) { // 当页面滚动超过100px时显示按钮
            $('#backToTop').fadeIn();
        } else {
            $('#backToTop').fadeOut();
        }
    });
 
    // 点击返回顶部按钮时的动作
    $('#backToTop').click(function() {
        $('html, body').animate({scrollTop: 0}, 800); // 滚动到页面顶部，持续时间为800毫秒
        return false; // 阻止默认行为（如果有的话）
    });
});

if (window.innerWidth< 768) {
    $(".footer-nav dt").click(function(){
        let $dl = $(this).parent();
        if($dl.hasClass("active")){
            $dl.removeClass("active");
        }else{
            $(".footer-nav dl").removeClass("active");
            $dl.addClass("active");
        }
    });
}

$("footer .right ul li").hover(function() {
    $(this).find(".link-pop").show();
},function() {
    $("footer .right ul li .link-pop").hide();
})
